import { render, staticRenderFns } from "./Betslip.vue?vue&type=template&id=aaa8b074&"
import script from "./betslip.js?vue&type=script&lang=js&"
export * from "./betslip.js?vue&type=script&lang=js&"
import style0 from "./Betslip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Betslip.vue"
export default component.exports